import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";

import { fadeIn, staggerContainer } from "../variants";

import { menuData } from "../data";

const Menu = () => {
  const { title, subtitle, dividerImg, iceCreamMenuItems, slushMenuItems } =
    menuData;

  const [menuButton, setMenuButton] = useState({
    isEnabled: true,
  });
  const [menuItems, setMenuItems] = useState([]);
  const [showCompleteMenu, setShowCompleteMenu] = useState(false);

  useEffect(() => {
    const initialIceCreamMenuItems = iceCreamMenuItems.slice(0, 4);
    setMenuItems(initialIceCreamMenuItems);
  }, [iceCreamMenuItems]);

  const toggleMenuHandler = () => {
    const completeMenuItems = showCompleteMenu
      ? iceCreamMenuItems.slice(0, 4)
      : [...iceCreamMenuItems, ...slushMenuItems];
    setMenuItems(completeMenuItems);
    setShowCompleteMenu(!showCompleteMenu);
  };

  return (
    <section className="min-h-[780px]">
      <div className="bg-red-300 h-[780px] bg-menu absolute w-full -z-0"></div>
      <div className="relative z-10 top-60 lg:top-36">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.1 }}
          className="container mx-auto flex flex-col items-center text-center"
        >
          <motion.h2
            variants={fadeIn("down", "tween", 0.4, 1.6)}
            className="h2 capitalize text-white max-w-[500px] text-center"
          >
            {title}
          </motion.h2>
          <motion.p
            variants={fadeIn("down", "tween", 0.6, 1.6)}
            className="text-white"
          >
            {subtitle}
          </motion.p>
          <motion.div variants={fadeIn("down", "tween", 0.8, 1.6)}>
            <img src={dividerImg} alt="" />
          </motion.div>
        </motion.div>
      </div>
      <motion.div
        initial={{
          opacity: 0,
          y: 150,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          type: "tween",
          delay: 0.2,
          duration: 1.6,
          ease: "backOut",
        }}
        className="relative top-60 lg:top-64"
      >
        <div className="container mx-auto">
          <div className="lg:-mt-16 min-h-[600px] z-30 mb-8 md:mb-4 xl:mb-8 flex justify-center">
            <div
              className={`grid grid-cols-1 ${
                showCompleteMenu
                  ? "lg:grid-cols-4 xl:grid-cols-4"
                  : "lg:grid-cols-4 xl:grid-cols-4"
              } lg:gap-[1rem] min-h-[600px]`}
            >
              {menuItems.map((item, index) => {
                const { image, name, description } = item;
                return (
                  <div
                    key={index}
                    className="flex flex-col lg:flex-col h-full mx-1"
                  >
                    <div>
                      <img
                        className="lg:rounded-tl-[200px] lg:rounded-tr-[200px]"
                        src={image}
                        alt=""
                      />
                    </div>
                    <div className="bg-red-200 border-red-300 flex-1 flex flex-col justify-center items-center px-6 w-[287px] lg:w-[275px] lg:max-h-[350px] lg:px-5 lg:pt-2 lg:pb-10 lg:rounded-b-full lg:border-b-[16px]">
                      <div className="text-center">
                        <div className="text-white text-xl font-semibold xl:text-lg">
                          {name}
                        </div>
                        <div className="text-white lg:text-base">
                          {description}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="flex justify-center items-center">
            <button
              className={`h-14 px-[42px] text-white text-base font-secondary font-semibold tracking-[0.02em] outline-none transition-all duration-300 flex justify-center items-center border-8
                  border-pink-700 bg-red-300 hover:bg-red-200 rounded-full capitalize mx-auto  lg:mx-0`}
              onClick={() => toggleMenuHandler()}
            >
              {showCompleteMenu ? "View Most Selling" : "View Complete Menu"}
            </button>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Menu;
